import { FunctionComponent, useState } from 'react'

import { useElement } from 'services/hooks'

import ForSaleTypeDropdown from '../Dropdowns/ForSaleTypeDropdown'
import { IFilterProps, IForSaleTypeProps } from '../types'
import FilterButton from './Shared/FilterButton'

/**
 * We display this as Sale Status but it is not 1:1 with our notion of Listing Status in the
 * model, so we will refer to it as For Sale Type in code instead to avoid confusion
 */
const ForSaleTypeFilter: FunctionComponent<IFilterProps & IForSaleTypeProps> = ({
  applyForSaleTypeSelection,
  resetForSaleTypeSelection,
  selectedForSaleTypes,
  setSelectedForSaleTypes,
  hide,
}) => {
  const [visible, setVisible] = useState(false)
  const [buttonRef, buttonElement] = useElement<HTMLDivElement>()

  const [applied, setApplied] = useState(false)
  const [label, setLabel] = useState('Sale Status')

  const clearSelection = () => {
    resetForSaleTypeSelection()
    setLabel('Sale Status')
    setApplied(false)
    setVisible(false)
  }

  const handleApply = () => {
    // equivalent to clearing the selection
    if (selectedForSaleTypes.length === 0) return clearSelection()

    applyForSaleTypeSelection()
    setApplied(true)

    if (selectedForSaleTypes.length === 0) setLabel('Sale Status')
    else if (selectedForSaleTypes.length === 1) setLabel(selectedForSaleTypes[0])
    else setLabel(selectedForSaleTypes.join(', '))

    setVisible(false)
  }

  return (
    <>
      <FilterButton
        ref={buttonRef}
        active={applied || visible}
        clearable={applied}
        label={label}
        onClearSelection={clearSelection}
        hide={hide}
      />
      <ForSaleTypeDropdown
        buttonElement={buttonElement}
        visible={visible}
        setVisible={setVisible}
        onApply={handleApply}
        selectedForSaleTypes={selectedForSaleTypes}
        setSelectedForSaleTypes={setSelectedForSaleTypes}
        applyForSaleTypeSelection={applyForSaleTypeSelection}
        resetForSaleTypeSelection={clearSelection}
      />
    </>
  )
}

export default ForSaleTypeFilter
